<template>
  <div id="vehicle-route-status" class="statusComponentDiv">
    <RequestInfo v-if="loading" :loader="loading" />

    <template v-for="(i) in this.phases">
      <!--<MapVehicleEntry :entry="i" :key="keyGen(i.vehicleLabel)" @click="selectedItem"></MapVehicleEntry>-->
      <div class="bus-indication" :key="i.stopTunnus+1000" v-if="i.stopOrder==vehicleStatus.passedStopNumber +1">
      </div>
      <div :key="i.stopTunnus">
        <div class="route-row" v-bind:class="{ passed: i.stopOrder<=vehicleStatus.passedStopNumber }">
          <div class="stopName" >{{i.stopRecord.nimi}}</div>
          <div class="routeline">
            <!--<svg height="30" width="30">-->
            <svg height="4em" width="2em" class="stop-indicator">
              <!--<line  preserveAspectRatio="none" height="100%" x1="50%" y1="0%" x2="50%" y2="100%" class="stop-line" />-->
              <line  preserveAspectRatio="none" height="100%" x1="50%" y1="0%" x2="50%" y2="100%"
                v-bind:class="{'stop-line': i.stopOrder>vehicleStatus.passedStopNumber, 'passed-stop-line': i.stopOrder<=vehicleStatus.passedStopNumber}" />
              <circle preserveAspectRatio="xMidYMid meet" cx="50%" cy="50%" r="6"
                v-bind:class="{'stop-circle': i.stopOrder>vehicleStatus.passedStopNumber, 'passed-stop-circle': i.stopOrder<=vehicleStatus.passedStopNumber}" />
            </svg>
          </div>
          <div class="scheduledTime">{{i.scheduledTime}}</div>
          <div class="actualTime" v-if="i.actualTime">({{i.actualTime}})</div>
          <div class="deviation" v-if="i.deviationSec">{{deviation(i.deviationSec)}}</div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import mapstore from '@/store/map/mapstore'
import stop from '@/store/timetable/stop'
import realtimeLogic from '@/services/realtimeLogic'

export default {
  name: 'VehicleStatusOnRoute',
  components: {
  },
    data: function() {
    return {
      stopList: null,
      vehicleStatus: null,
      phases: [],
      loading: true
    }
  },
  props: {
   vehicleLabel: {default: null}
   // msg: {type: number, default: null}
  },
  beforeCreate: function() {
    if (!this.$store.state.stop) {
      this.$store.registerModule("stop" , stop);
    }
    if (!this.$store.state.mapstore) {
      this.$store.registerModule("mapstore" , mapstore);
    }
  },
  beforeDestroy() {
      clearInterval(this.interval)
  },
  watch: {
  },
  mounted() {
    this.fetchVehicleRouteStatus()
    this.interval = setInterval(this.fetchVehicleRouteStatus, 10000)
  },
  computed: {
  },
  methods: {
    fetchVehicleRouteStatus() {
      this.$store
        .dispatch('stop/getStopList', this.$props.vehicleLabel)
        .then((data) => {
          var $vm = this
          $vm.stopList = data
          $vm.mergeData()
        })
        .catch((error) => {
          console.error('Failed to get stop list:', error)
        })
      // Nouda reitin tiedo
      this.$store
        .dispatch('mapstore/getVehicleStatusOnRoute', this.$props.vehicleLabel)
        .then((data) => {
          var $vm = this
          $vm.vehicleStatus = data
          $vm.mergeData()
        })
        .catch((error) => {
          console.error('Failed to get vehicle status on route:', error)
        })
    },
    mergeData: function() {
      if(this.stopList == null || this.vehicleStatus == null) {
        return;
      }
      var stopit = this.stopList;
      this.phases = this.vehicleStatus.routeStops;
      if(this.$UiConfig('data/vehicle/stopOrder', "asc") == "desc" ) {
        this.phases.reverse(); 
      }  
      if(this.phases == null) {
        return;
      }
      this.phases.forEach((s)=>{
        var pysakki = stopit.find((p)=>{return p.tunnus == s.stopTunnus});
        s.stopRecord = pysakki;
      });
      this.loading = false;

      //this.adjustComponentHeight();

    },
    deviation: function(dev) {
      const deviation = realtimeLogic.getDeviationInRightFormat2(dev, true);
      if (!deviation) {
        return '';
      }
      return deviation;
    },
    
    adjustComponentHeight(){
      var elem = document.getElementById('vehicle-slide-in');
      var cStyle = getComputedStyle(elem);
      var vPadding = parseInt(cStyle.paddingTop)  + parseInt(cStyle.paddingBottom);
      var slideInHeight = elem.offsetHeight - vPadding;
      //console.log(slideInHeight);
      
      elem = document.getElementById('vehicle-info');
      cStyle = getComputedStyle(elem);
      var vMargin = parseInt(cStyle.marginTop) + parseInt(cStyle.marginBottom);
      var infoHeight = elem.offsetHeight + vMargin;
      //console.log(infoHeight);
     
      elem = document.getElementById('vehicle-route-status');
      cStyle = getComputedStyle(elem);
      vMargin = parseInt(cStyle.marginTop) + parseInt(cStyle.marginBottom);
      vPadding = parseInt(cStyle.paddingTop)  + parseInt(cStyle.paddingBottom);

      var availableHeight = slideInHeight - infoHeight - vMargin - vPadding - 20;
      elem.style.height = availableHeight + "px";

      // console.log(vMargin + "/" + vPadding);
      //console.log(availableHeight);
     
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

div.statusComponentDiv {
  overflow: auto;
  font-size: 0.7rem;
  height: 200px;
  margin-top: 30px;

  height: calc(100vh - 150px);
  overflow-y: auto; 
  overflow-x: hidden;

}
div.passed {
  color: #6f6f6f;
}

div.bus-indication {
  border-bottom: dotted;
  border-color: #cb4242;
  border-width: thick;
}
div.stopName {
  width: 8em;
  display: flex;
  align-items: center;
}
div.route-row {
  padding-top: 0.0em;
  display: flex;
}
div.scheduledTime,div.actualTime,div.deviation {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 0.5em;
  padding-bottom: 0.5em;
  padding-left: 0.5em;
}
.stop-line {
  stroke: #0d4b29;
  stroke-width:3;
}
.passed-stop-line {
  fill:  #aab8b1;
  stroke: #aab8b1;
  stroke-width:3;
}

.passed-stop-circle {
  fill:  #aab8b1;
  stroke: #aab8b1;
  stroke-width: 2;
}
.stop-circle {
  stroke: #0d4b29;
  stroke-width: 2;
  fill: #55b282;
}
</style>
